import { useSnackbar } from "notistack";

// MUI
import { IconButton } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

type SnackbarsActionsProps = {
	index: number | string;
};

export default function SnackbarsActions(props: Readonly<SnackbarsActionsProps>) {
	const { closeSnackbar } = useSnackbar();

	const close = () => {
		closeSnackbar(props.index);
	};

	return (
		<IconButton className="snackbars-actions close" onClick={close} size="small">
			<CloseRoundedIcon fontSize="small" />
		</IconButton>
	);
}
